import { createContext, useContext } from 'react';
import { ModuleEntitlementsContextType } from '../types';

// ----------------------------------------------------------------------

export const ModuleEntitlementsContext = createContext({} as ModuleEntitlementsContextType);

export const useModuleEntitlements = () => {
    const context = useContext(ModuleEntitlementsContext);

    if (!context) throw new Error('useModuleEntitlements must be used inside ModuleEntitlementsProvider');

    return context;
};
